import React from 'react'
import TagData from './Tags.json'
import "./Body.css"


function GameTags({name}) {

 
const tagDataArray = TagData[name][0].tags;

  return (
    <div>
      <ul class="tags">
      {tagDataArray.map(name => (  
          <li>  
            {name}  
          </li>  
        ))}
      </ul>
      
    </div>
  )
}

export default GameTags